import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { LogglyService } from 'src/app/services/loggly.service';
import { SubscriptionsService } from '../services/subscriptions.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard  {
  constructor(private router: Router, private configService: ConfigService, private logglyService: LogglyService, private subscriptionsService: SubscriptionsService) {

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let loginDetails = JSON.parse(localStorage.getItem('admin_Details') ?? 'null');
    let subscriptionDetails = JSON.parse(localStorage.getItem('SubscriptionFeatures') ?? 'null');
    this.subscriptionsService.subscriptionFeatures$.subscribe((features: any) => {
      if (features) {
        subscriptionDetails = features;
      }
    });
    const fullUrl = state.url;
    
    // Not logged in
    if (!loginDetails?.UserID) {
       this.logglyService.log('AuthGuard - loginDetails missing, redirecting to login page.');
       this.configService.sessionLogout();
      return false;
    }
    // If route has a requiredRole (superadmin) in its data, check it
    const requiredRole = route.data['requiredRole'];
    if (requiredRole && loginDetails.UserType !== requiredRole) {
      this.router.navigate(['/dashboard/summary']);
      return false;
    }
    return true;
  }

}
